/**
 * Determine whether the provided event can be promoted by confirming that
 * there is enough time to promote it.
 *
 * @param event
 * @param earliestPromotionIso ISO8601 string of the earliest data a promotion can start
 * @param shortestPromotionWindow The minimum number of days required before the event ends
 * @returns {boolean}
 */
export function eventIsPromotable(event, earliestPromotionIso, shortestPromotionWindow) {
	let earliestEventPromoStartDate = new Date(event.endIso)
	earliestEventPromoStartDate.setDate(earliestEventPromoStartDate.getDate() - shortestPromotionWindow)

	let startsAfterEarliestIso = new Date(event.startIso) >= new Date(earliestPromotionIso)
	let hasSaneDateRange = earliestEventPromoStartDate >= new Date(earliestPromotionIso)

	return startsAfterEarliestIso && hasSaneDateRange
}
